
import ShowTipContent from '@com/components/show-tips-content/index.vue';
import { language } from '@/common/storage';

export default {
  components: { ShowTipContent: ShowTipContent },
  props: {
    name: {
      type: String,
      required: true
    },

    detail: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    playMethods: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    difficultyLevel: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    tag: [String],
    description: [String],
    pageType: [String],
    dimension_type: [Number],
    model_count: [Number],
    action_count: [Number]
  },
  data: function data() {
    return {
      putAway: true
    };
  },

  computed: {
    innerDesc: function innerDesc() {
      return this.description.length > 50 ? this.description.substring(0, 51) + '...' : this.description;
    },
    showPutAway: function showPutAway() {
      return this.playMethods.length > 3;
    },
    styles: function styles() {
      return {
        height: this.putAway && this.showPutAway ? '65px' : 'auto'
      };
    },
    getDimensionType: function getDimensionType() {
      var _this = this;

      var type = '-';
      var o = (this.$store.state.config.gmaker.dimension_types || []).find(function (item) {
        return item.id === _this.dimension_type;
      }) || {};
      if (language.get() === 'zh-cn') {
        type = o.name || '-';
      } else {
        type = o.name_en || '-';
      }
      return type;
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.putAway = !this.putAway;
    }
  }
};